export default "__VITE_ASSET__DIp0BSPu__"